import axios from "axios";
import { Urls } from "../../../store/urls";

export const getDegreeOrderingRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.CMS_DEGREE_ORDERING,
        params: params,
    });
};

export const getDegreeOrderingDomainRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.CMS_DEGREE_ORDERING,
        params: params,
    });
};

export const postDegreeOrderingRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.CMS_DEGREE_ORDERING,
        data: data,
    });
};